import { useAtomValue } from 'jotai'
import { FC } from 'react'
import { ParcelMap as ParcelMapBase } from 'src/v2/components/parcel-map'
import * as atoms from 'src/v2/state/owner-reveal/entity-parcels'

export const ParcelMap: FC = () => {
  const parcel = useAtomValue(atoms.selectedParcel)
  const zoningDetails = useAtomValue(atoms.selectedParcelZoningDetails)

  return <ParcelMapBase height={200} geometry={parcel?.geometry} mCode={zoningDetails?.mCode} />
}
